"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iconFactory_1 = require("../../utils/iconFactory");
// AEM-Name: BedSingleIcon
exports.BedSingleIcon = iconFactory_1.iconFactory({
    componentName: 'BedSingleIcon',
    viewBox: '0 0 283.5 283.5',
    title: 'BedSingleIcon',
    g: "<path d=\"M255.1,152.4v2.2v29.7h-14.2V160c0-4.2-3.4-7.7-7.7-7.7H50.2c-4.2,0-7.7,3.4-7.7,7.7v24.3H28.3v-77.9H14.2v134.5h14.2v-42.5&#xA;&#x9;h226.8v40.3v2.2h14.2v-2.2v-84.2v-2.2H255.1z M226.8,184.3H99.2v-17.7l127.5,0V184.3z M56.7,166.5l28.3,0v17.7H56.7V166.5z\"/>",
    gThemed: { "ergo-one": { "viewBox": "0 0 283.5 283.5", "g": "<path d=\"M255.1,152.4v2.2v29.7h-14.2V160c0-4.2-3.4-7.7-7.7-7.7H50.2c-4.2,0-7.7,3.4-7.7,7.7v24.3H28.3v-77.9H14.2v134.5h14.2v-42.5&#xA;&#x9;h226.8v40.3v2.2h14.2v-2.2v-84.2v-2.2H255.1z M226.8,184.3H99.2v-17.7l127.5,0V184.3z M56.7,166.5l28.3,0v17.7H56.7V166.5z\"/>" } }
});
exports.default = exports.BedSingleIcon;
//# sourceMappingURL=BedSingleIcon.js.map